/**
 * M1o2 Product Card Hero - home "Daily Hustle" 3-card strip.
 * - Size pills: switch the card's selected variant (id + price) without navigation.
 * - ADD TO CART: posts /cart/add.js, then broadcasts Dawn's PUB_SUB_EVENTS.cartUpdate
 *   (refreshes header count / cart-drawer-items - same convention as assets/m1o2-cart-drawer.js)
 *   and opens Dawn's <cart-drawer> directly (same convention as assets/m1o2-main.js's cart
 *   utility link), since publishing cartUpdate alone only refreshes an already-open drawer.
 *   Falls back to a native form submit if fetch fails or cart-drawer isn't present.
 */
(function () {
	'use strict';

	function cartAddUrl() {
		return (window.routes && window.routes.cart_add_url) || '/cart/add.js';
	}

	function cartUrl() {
		return (window.routes && window.routes.cart_url) || '/cart';
	}

	/* ---- Size pills ---- */
	function selectPill(pill) {
		if (pill.hasAttribute('disabled')) return;

		var card = pill.closest('[data-pch-card]');
		if (!card) return;

		var pills = card.querySelectorAll('[data-pch-pill]');
		Array.prototype.forEach.call(pills, function (p) {
			var on = p === pill;
			p.classList.toggle('m1o2-product-card-hero__card-pill--on', on);
			p.setAttribute('aria-pressed', on ? 'true' : 'false');
		});

		var variantInput = card.querySelector('[data-pch-variant-input]');
		if (variantInput) variantInput.value = pill.getAttribute('data-variant-id');

		/* Per-size copy + image (snippets/m1o2-variant-card-data.liquid). The hooks are only
		   rendered when the block has no copy/image override; a size with no image of its
		   own keeps the current one. */
		var descEl = card.querySelector('[data-pch-desc]');
		var desc = pill.getAttribute('data-variant-desc');
		if (descEl && desc) descEl.textContent = desc;
		var imgEl = card.querySelector('[data-pch-img]');
		var img = pill.getAttribute('data-variant-image');
		if (imgEl && img) {
			imgEl.removeAttribute('srcset');
			imgEl.src = img;
		}

		var available = pill.getAttribute('data-variant-available') === 'true';
		var price = pill.getAttribute('data-variant-price');

		var addBtn = card.querySelector('[data-pch-add]');
		if (addBtn) {
			addBtn.disabled = !available;
			var textEl = addBtn.querySelector('.m1o2-product-card-hero__card-cart-text');
			if (textEl) {
				textEl.innerHTML = available
					? 'ADD TO CART - <span data-pch-price>' + (price || '') + '</span>'
					: 'SOLD OUT';
			}
		}
	}

	/* ---- Cart drawer open + refresh ---- */
	function openCartDrawer(trigger) {
		var drawer = document.querySelector('cart-drawer');
		if (drawer && typeof drawer.open === 'function') {
			drawer.open(trigger);
			return true;
		}
		return false;
	}

	function broadcastCartUpdate() {
		return fetch(cartUrl() + '.js')
			.then(function (response) {
				return response.json();
			})
			.then(function (cart) {
				if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
					publish(PUB_SUB_EVENTS.cartUpdate, { source: 'm1o2-product-card-hero', cartData: cart });
				}
			})
			.catch(function () {
				/* non-fatal - the item is already added; header count just won't refresh */
			});
	}

	/* ---- ADD TO CART ---- */
	function addToCart(form) {
		var button = form.querySelector('[data-pch-add]');
		var input = form.querySelector('[data-pch-variant-input]');
		if (!button || !input || !input.value || button.getAttribute('aria-busy') === 'true') return;

		button.setAttribute('aria-busy', 'true');

		fetch(cartAddUrl(), {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify({ items: [{ id: input.value, quantity: 1 }] })
		})
			.then(function (response) {
				return response.json().then(function (data) {
					if (!response.ok) throw new Error((data && data.description) || 'Add to cart failed');
					return data;
				});
			})
			.then(function () {
				return broadcastCartUpdate();
			})
			.then(function () {
				if (!openCartDrawer(button)) window.location.href = cartUrl();
			})
			.catch(function () {
				/* fetch/JS failed - fall back to a real navigation so the add still happens */
				form.submit();
			})
			.finally(function () {
				button.removeAttribute('aria-busy');
			});
	}

	document.addEventListener('click', function (event) {
		var pill = event.target.closest('[data-pch-pill]');
		if (!pill) return;
		event.preventDefault();
		selectPill(pill);
	});

	document.addEventListener('submit', function (event) {
		var form = event.target.closest('.m1o2-product-card-hero__card-cart-form');
		if (!form) return;
		event.preventDefault();
		addToCart(form);
	});

	/* ---- Carousel ----
	 * The desktop strip is a native overflow-x scroller with CSS scroll-snap, so swipe,
	 * trackpad, wheel and keyboard all work on their own, and the design (2415:40106) has
	 * no arrow controls - its only affordance is the 4th card peeking at the panel edge.
	 * Mobile (778:7573) stacks the cards vertically instead of scrolling (pure CSS).
	 * The one addition is mouse drag-to-scroll: mouse pointers only (touch already scrolls
	 * natively), inert when the track isn't overflowing (mobile stack), snap suspended
	 * while dragging, and the click that ends a real drag is swallowed so it can't follow
	 * a card link or press a pill / ADD TO CART.
	 */
	var DRAG_THRESHOLD = 5;
	/* A release this far past the start (px) advances at least one card, carousel-style. */
	var FLICK_DISTANCE = 40;

	function initDrag(track) {
		var startX = 0;
		var startScroll = 0;
		var pointerId = null;
		var dragging = false;
		var suppressClick = false;
		var restoreTimer = null;

		function scrollable() {
			return track.scrollWidth > track.clientWidth + 1;
		}

		/* Snap + smooth scrolling are switched off INLINE, not via a class: with
		   scroll-snap-type: x mandatory still active, every scrollLeft write is snapped
		   straight back, so the track never moves. Doing it in JS also means it can't be
		   defeated by a stale {% stylesheet %} bundle. */
		function freeScroll() {
			clearTimeout(restoreTimer);
			track.style.scrollSnapType = 'none';
			track.style.scrollBehavior = 'auto';
		}

		function restoreSnap() {
			track.style.scrollSnapType = '';
			track.style.scrollBehavior = '';
		}

		/* scrollLeft values at which each card sits flush with the track's start padding
		   (the same position CSS scroll-snap would pick). */
		function snapPoints() {
			var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
			var trackLeft = track.getBoundingClientRect().left;
			var max = track.scrollWidth - track.clientWidth;
			var cards = track.querySelectorAll('[data-pch-card]');
			var points = [];
			Array.prototype.forEach.call(cards, function (card) {
				var left = track.scrollLeft + card.getBoundingClientRect().left - trackLeft - pad;
				points.push(Math.max(0, Math.min(max, Math.round(left))));
			});
			return points;
		}

		function settle(dx) {
			var points = snapPoints();
			var current = track.scrollLeft;
			var target = current;
			if (points.length) {
				var nearest = 0;
				points.forEach(function (p, i) {
					if (Math.abs(p - current) < Math.abs(points[nearest] - current)) nearest = i;
				});
				var index = nearest;
				/* Dragging left (dx < 0) moves forward. Guarantee a flick lands on a new card
				   in the drag's direction rather than bouncing back to where it started. */
				if (dx <= -FLICK_DISTANCE && points[index] <= startScroll) index++;
				if (dx >= FLICK_DISTANCE && points[index] >= startScroll) index--;
				index = Math.max(0, Math.min(points.length - 1, index));
				target = points[index];
			}
			track.scrollTo({ left: target, behavior: 'smooth' });
			/* Re-enable CSS snap only once the glide has finished, or it would cut it short. */
			restoreTimer = setTimeout(restoreSnap, 600);
		}

		function endDrag() {
			if (pointerId === null) return;
			var wasDragging = dragging;
			var id = pointerId;
			pointerId = null;
			dragging = false;
			track.classList.remove('is-dragging');
			if (wasDragging) {
				if (track.hasPointerCapture(id)) track.releasePointerCapture(id);
				settle(lastX - startX);
			}
		}

		var lastX = 0;

		track.addEventListener('pointerdown', function (event) {
			if (event.pointerType !== 'mouse' || event.button !== 0 || !scrollable()) return;
			pointerId = event.pointerId;
			startX = lastX = event.clientX;
			startScroll = track.scrollLeft;
			dragging = false;
			suppressClick = false;
		});

		track.addEventListener('pointermove', function (event) {
			if (event.pointerId !== pointerId) return;
			lastX = event.clientX;
			var dx = lastX - startX;
			if (!dragging) {
				if (Math.abs(dx) < DRAG_THRESHOLD) return;
				/* Capture only once it's a real drag, so a plain click keeps its own target. */
				dragging = true;
				suppressClick = true;
				freeScroll();
				startScroll = track.scrollLeft;
				startX = lastX;
				dx = 0;
				track.setPointerCapture(pointerId);
				track.classList.add('is-dragging');
			}
			event.preventDefault();
			track.scrollLeft = startScroll - dx;
		});

		track.addEventListener('pointerup', endDrag);
		track.addEventListener('pointercancel', endDrag);
		track.addEventListener('lostpointercapture', endDrag);

		track.addEventListener(
			'click',
			function (event) {
				if (!suppressClick) return;
				suppressClick = false;
				event.preventDefault();
				event.stopPropagation();
			},
			true
		);

		/* Native image/link drag and text selection would hijack the gesture. */
		track.addEventListener('dragstart', function (event) {
			event.preventDefault();
		});
	}

	function initTracks() {
		var tracks = document.querySelectorAll('[data-pch-track]:not([data-pch-drag])');
		Array.prototype.forEach.call(tracks, function (track) {
			track.setAttribute('data-pch-drag', '');
			initDrag(track);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initTracks);
	} else {
		initTracks();
	}
	/* Theme editor re-renders the section in place. */
	document.addEventListener('shopify:section:load', initTracks);
})();
